<template>
  <!-- Ficha de cabecera del Portfolio: indicadores agregados de toda la cartera. -->
  <summary-card :title="$t('prm_portfolio_kpis_title')" :subtitle="subtitle" :mode="mode">
    <table class="ficha">
      <thead>
        <tr>
          <th class="ic-col"></th>
          <th>{{ $t('prm_dash_col_indicator') }}</th>
          <th class="r">{{ $t('prm_dash_col_value') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="row in rows" :key="row.key">
          <td class="ic-col">
            <span class="ic" :style="{ background: iconColor(row) + '22', color: iconColor(row) }">
              <b-icon pack="fas" :icon="row.icon" size="is-small"></b-icon>
            </span>
          </td>
          <td class="lbl-col">
            <span class="lbl">{{ $t(row.label) }}</span>
            <source-chip v-if="mode" :source="row.source"></source-chip>
          </td>
          <td class="val-col"><b :style="{ color: row.accent || '#1e3046' }">{{ row.value }}</b></td>
        </tr>
      </tbody>
    </table>
  </summary-card>
</template>

<script>
  import SummaryCard from '../summary/summary-card.vue'
  import SourceChip from '../summary/source-chip.vue'
  import { fmtEur, fmtPct, fmtEurSigned } from '../shared/format'
  import { ACCENT } from '../dashboard/dashboard-model'

  export default {
    name: 'PrmPortfolioKpiSummary',

    components: { SummaryCard, SourceChip },

    props: {
      kpis: { type: Object, required: true }, // salida de portfolioKpis()
      subtitle: { type: String, default: '' },
      mode: { type: Boolean, default: false },
    },

    computed: {
      rows () {
        const k = this.kpis
        return [
          { key: 'num', icon: 'diagram-project', label: 'prm_portfolio_kpi_num', source: 'admin', value: String(k.numProjects) },
          { key: 'sale', icon: 'sack-dollar', label: 'prm_portfolio_kpi_total_sale', source: 'prm', value: fmtEur(k.totalSale) },
          { key: 'backlog', icon: 'boxes-stacked', label: 'prm_portfolio_kpi_backlog', source: 'calc', value: fmtEur(k.backlogTotal) },
          { key: 'mcom', icon: 'percent', label: 'prm_portfolio_kpi_avg_commercial_margin', source: 'calc', value: fmtPct(k.avgCommercialMargin) },
          { key: 'mact', icon: 'percent', label: 'prm_portfolio_kpi_avg_actual_margin', source: 'calc', value: fmtPct(k.avgActualMargin) },
          { key: 'mdev', icon: 'arrow-trend-up', label: 'prm_portfolio_kpi_margin_dev', source: 'calc',
            value: fmtEurSigned(k.marginDevTotal), accent: k.marginDevTotal < 0 ? ACCENT.bad : ACCENT.good },
          { key: 'co', icon: 'circle-plus', label: 'prm_portfolio_kpi_change_orders', source: 'prm', value: fmtEur(k.changeOrdersTotal) },
          { key: 'poc', icon: 'chart-pie', label: 'prm_portfolio_kpi_avg_poc', source: 'calc', value: fmtPct(k.avgPoc) },
          { key: 'crit', icon: 'triangle-exclamation', label: 'prm_portfolio_kpi_critical', source: 'calc',
            value: String(k.criticalProjects), accent: k.criticalProjects > 0 ? ACCENT.bad : ACCENT.good },
          { key: 'crisk', icon: 'file-contract', label: 'prm_portfolio_kpi_contractual_risk', source: 'resumen',
            value: String(k.contractualRiskProjects), accent: k.contractualRiskProjects > 0 ? ACCENT.warn : ACCENT.good },
          { key: 'osh', icon: 'helmet-safety', label: 'prm_portfolio_kpi_osh', source: 'incid',
            value: String(k.oshProjects), accent: k.oshProjects > 0 ? ACCENT.bad : ACCENT.good },
        ]
      },
    },

    methods: {
      // Color del icono: el acento de la fila, o azul neutro si no tiene.
      iconColor (row) { return row.accent || '#3a6bc8' },
    },
  }
</script>

<style lang="scss" scoped>
  .ficha { width: 100%; border-collapse: collapse; }
  .ficha th {
    background: #3d6b9a; color: #fff; font-size: 9px; text-transform: uppercase; letter-spacing: .03em;
    font-weight: 700; padding: 5px 10px; text-align: left; white-space: nowrap;
  }
  .ficha th.r { text-align: right; }
  .ficha td { border-bottom: 1px solid #eef0f3; padding: 5px 10px; vertical-align: middle; }
  // Cebra + hover, como el resto de tablas.
  .ficha tbody tr:nth-child(even) td { background: #f9fafb; }
  .ficha tbody tr:hover td { background: #eef2f7; }

  .ic-col { width: 34px; }
  .ic {
    display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px;
    border-radius: 6px; font-size: 11px;
  }
  .lbl-col { width: 60%; }
  .lbl { font-size: 11px; color: #1e3046; font-weight: 600; }
  .val-col { text-align: right; white-space: nowrap; }
  .val-col b { font-size: 12px; font-weight: 700; font-variant-numeric: tabular-nums; }
</style>
